<template>
  <div
    :class="['normalBtn', isGray ? 'backgroundGray' : '', isWhiteBg ? 'whiteBg': '']"
    @click="onClickBtnFn"
  >
    <div :style="fontStyle">
      {{ labBtn }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NormalBtn',
  props: {
    isGray: {
      type: Boolean,
      default: false,
    },
    btnType: {
      type: String,
      default: '',
    },
    labBtn: {
      type: String,
      default: '',
    },
    labStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isWhiteBg() {
      return this.btnType === 'whiteBg';
    },
    fontStyle() {
      let style = {
        color: '#FFFFFF',
        fontSize: '0.18rem',
      };
      if (this.isWhiteBg) {
        style = {
          ...style,
          color: '#0B82F1',
        };
      }
      if (this.labStyle) {
        style = {
          ...style,
          ...this.labStyle,
        };
      }
      return style;
    },
  },
  methods: {
    onClickBtnFn(e) {
      this.$emit('e-click', e);
    },
  },
};
</script>

<style scoped lang="less">
.normalBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background:rgba(11,130,241,100%);
  border-radius:0.06rem;
}

.whiteBg {
  background:rgba(255,255,255,100%);
  border-radius:0.06rem;
  border:1px solid rgba(238,238,238,100%);
}

.labBtn {
  color: #FFF;
  font-size: 0.18rem;
}

.backgroundGray {
  background:rgba(204,204,204,100%);
}
</style>
